import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as pedidosApi from '../../api/pedidos';
import PageHeader from '../../components/common/PageHeader';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import StatusBadge from '../../components/common/StatusBadge';
import { formatDate, formatDateTime } from '../../utils/date';
import { getErrorMessage } from '../../utils/apiError';

export default function PedidoDetalhe() {
  const { id } = useParams();
  const [pedido, setPedido] = useState(null);
  const [loading, setLoading] = useState(true);
  const [processando, setProcessando] = useState(false);
  const [erro, setErro] = useState('');

  const carregar = () => {
    setLoading(true);
    pedidosApi
      .getPedido(id)
      .then((r) => setPedido(r.data))
      .catch(() => setErro('Erro ao carregar pedido.'))
      .finally(() => setLoading(false));
  };

  useEffect(carregar, [id]);

  const confirmar = async () => {
    setProcessando(true);
    setErro('');
    try {
      await pedidosApi.confirmarPedido(id);
      carregar();
    } catch (err) {
      setErro(getErrorMessage(err, 'Erro ao confirmar pedido.'));
    } finally {
      setProcessando(false);
    }
  };

  const cancelar = async () => {
    if (!window.confirm('Tem certeza que deseja cancelar este pedido?')) return;
    setProcessando(true);
    setErro('');
    try {
      await pedidosApi.cancelarPedido(id);
      carregar();
    } catch (err) {
      setErro(getErrorMessage(err, 'Erro ao cancelar pedido.'));
    } finally {
      setProcessando(false);
    }
  };

  if (loading) return <LoadingSpinner />;
  if (!pedido) return <div className="sf-login-alert"><i className="bi bi-exclamation-circle" />{erro}</div>;

  return (
    <div>
      <PageHeader titulo={`Pedido — ${pedido.cliente ? pedido.cliente.nome : 'Venda avulsa'}`} subtitulo={formatDate(pedido.data_pedido)} />
      {erro && (
        <div className="sf-login-alert mb-3">
          <i className="bi bi-exclamation-circle" />
          {erro}
        </div>
      )}

      <div className="sf-card p-4 mb-3">
        <div className="row g-3">
          <div className="col-md-3">
            <div className="sf-cell-sub mb-1">Status</div>
            <StatusBadge status={pedido.status} />
          </div>
          <div className="col-md-3">
            <div className="sf-cell-sub mb-1">Criado em</div>
            <div>{formatDateTime(pedido.created_at)}</div>
          </div>
          {pedido.confirmado_em && (
            <div className="col-md-3">
              <div className="sf-cell-sub mb-1">Confirmado em</div>
              <div>{formatDateTime(pedido.confirmado_em)}</div>
            </div>
          )}
          {pedido.cancelado_em && (
            <div className="col-md-3">
              <div className="sf-cell-sub mb-1">Cancelado em</div>
              <div>{formatDateTime(pedido.cancelado_em)}</div>
            </div>
          )}
        </div>
        {pedido.observacoes && (
          <div className="mt-3">
            <div className="sf-cell-sub mb-1">Observações</div>
            <div>{pedido.observacoes}</div>
          </div>
        )}
      </div>

      <div className="sf-table-card mb-3">
        <div className="sf-table-toolbar">
          <span style={{ fontWeight: 800, fontSize: 15 }}>Itens</span>
        </div>
        <div className="table-responsive">
          <table className="sf-table">
            <thead>
              <tr>
                <th>Produto</th>
                <th>Qualidade</th>
                <th>Lote</th>
                <th>Quantidade</th>
              </tr>
            </thead>
            <tbody>
              {pedido.itens.map((item) => (
                <tr key={item.id_item_pedido}>
                  <td>
                    <span className="d-flex align-items-center gap-2">
                      <span className="sf-cell-icon"><i className="bi bi-box-seam" /></span>
                      <span className="sf-cell-title">{item.item_lote.lote.produto.nome}</span>
                    </span>
                  </td>
                  <td>{item.item_lote.qualidade.nome}</td>
                  <td>{item.item_lote.lote.codigo}</td>
                  <td>{Number(item.quantidade)} {item.item_lote.unidade_medida.sigla}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {pedido.status === 'rascunho' && (
        <div className="d-flex gap-2">
          <button type="button" className="sf-btn sf-btn-primary" disabled={processando} onClick={confirmar}>
            <i className="bi bi-check-circle" />
            Confirmar pedido
          </button>
          <button
            type="button"
            className="sf-btn sf-btn-ghost"
            style={{ color: 'var(--sf-danger-fg)', borderColor: '#f0cfcc' }}
            disabled={processando}
            onClick={cancelar}
          >
            Cancelar
          </button>
        </div>
      )}
      {pedido.status === 'confirmado' && (
        <button
          type="button"
          className="sf-btn sf-btn-ghost"
          style={{ color: 'var(--sf-danger-fg)', borderColor: '#f0cfcc' }}
          disabled={processando}
          onClick={cancelar}
        >
          <i className="bi bi-x-circle" />
          Cancelar pedido (devolve estoque)
        </button>
      )}
    </div>
  );
}
